import axios from "axios";

export async function uploadToCloudinary(
  file: File,
  options?: {
    osName?: string;
    isMobile?: boolean;
    isTablet?: boolean;
    browserName?: string;
    clientIp?: string;
    admin?: any;
    getCookie?: (name: string) => string | undefined;
  }
): Promise<string> {
  if (!file) {
    throw new Error("No file provided");
  }

  // 🔎 File type validation
  const validImageTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
  const validVideoTypes = ['video/mp4', 'video/webm', 'video/ogg', 'video/quicktime', 'video/x-msvideo'];
  const validTypes = [...validImageTypes, ...validVideoTypes];

  if (!validTypes.includes(file.type)) {
    throw new Error(`Invalid file type: ${file.type}`);
  }

  const isVideo = validVideoTypes.includes(file.type);

  // 📦 Size validation
  const maxSize = isVideo ? 100 * 1024 * 1024 : 10 * 1024 * 1024;
  if (file.size > maxSize) {
    throw new Error(`File too large. Max size: ${isVideo ? "100MB" : "10MB"}`);
  }

  const formData = new FormData();
  formData.append("file", file);

  try {
    console.log("process.env.REACT_APP_FILE_UPLOAD_URL", process.env.REACT_APP_FILE_UPLOAD_URL)
    const response = await axios.post(
      process.env.REACT_APP_FILE_UPLOAD_URL as string || "https://files.salar.in/api/v1/files/upload",
      formData,
      {
        headers: {
          accept: "*/*",
          "x-os": options?.osName || "macos",
          "x-device": options?.isMobile
            ? "mobile"
            : options?.isTablet
            ? "tablet"
            : "desktop",
          "x-browser": options?.browserName || "chrome",
          "x-ip-address": options?.clientIp || "127.1.1.0",
          "x-staff-role": options?.admin?.roles || "staffRole",
          "x-staff-name": options?.admin?.name || "staffName",
          "x-staff-id": options?.admin?._id || "",
          "x-api-key": options?.getCookie?.("access_token") || "",
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (!response.data?.success) {
      throw new Error(response.data?.message || "Upload failed");
    }

    const uploadedUrl = response.data?.data?.url;

    if (!uploadedUrl) {
      throw new Error("No URL returned from server");
    }

    return uploadedUrl;
  } catch (error: any) {
    console.error("Upload error:", error);
    throw new Error(
      error.response?.data?.message || error.message || "Upload failed"
    );
  }
}